export default __webpack_public_path__ + "static/media/bg.6d9ab369.png";